/** ERP grupo for biometric cache validity lookup */
export const BIOMETRY_UNICO_PARAM_GROUP = "BIOMETRIA_UNICO";

/** Parameter key for reuse window in days (Wayup busca-prazo-validade-bio) */
export const CACHE_CONSULTAS_UNICO_PARAMETER = "CACHE_CONSULTAS_UNICO";

/** Same label as Nest `BIOMETRY_FLOW_PROCESS_RESULT` / ERP */
export const UNICO_FLOW_PROCESS_RESULT_TYPE = "Resultado do Processo";

export const DEFAULT_BIOMETRY_REUSE_CACHE_DAYS = 1;

export const MINUTES_PER_DAY = 1440;
